import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const HEADER_STRINGS = appStrings.modules.lifeReadiness.header;

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Dashboard Header',
    description:
      'Page header with title, description text, and a CTA card prompting the user to start or continue the Life Readiness quiz.',
    detail: [HEADER_STRINGS.title, HEADER_STRINGS.description].join('\n'),
  });
};
